import { render, staticRenderFns } from "./inheritAdd.vue?vue&type=template&id=3c2b4607&scoped=true"
import script from "./inheritAdd.vue?vue&type=script&lang=js"
export * from "./inheritAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2b4607",
  null
  
)

export default component.exports